import { UserPermissionsForm } from './UserPermissionsForm';
import React, { Fragment } from 'react';
import {Theme} from '@mui/material';
import styled from 'styled-components';
import { UserTypes } from '../../../store/ceclapi/types';
import Link from '@mui/material/Link';
import { colors } from '../../../utils/theme';
import { makeStyles } from 'tss-react/mui';

export const NotificationsOrAdminPermissions = props => {
  const {
    user,
    currentUser,
    togglePermission,
    setEnabledAdmin,
    enableAdmin
  } = props;

  const currentUserIsAdmin = currentUser.userType == UserTypes.Admin;
  const currentUsersProfile = user && currentUser && user.objectId == currentUser.userObjectId;
  const { classes, cx } = useStyles();

  const LPLinkPlain = props => {
    const { component: LinkComponent = Link, hitServer, to } = props;
  
    const StyledLink = styled(LinkComponent)`
      color: ${colors.blackTwo};
      text-decoration: none;
    `;
  
    const handleClick = e => {
      if (props.onClick) {
        props.onClick(e);
        return false;
      }
      if (hitServer) {
        e.preventDefault();
        window.location.assign(to);
      } else {
        return true;
      }
    };
  
    return <StyledLink {...props} onClick={handleClick}></StyledLink>;
  };

  if (currentUserIsAdmin) {
    return (
      <Fragment>
        <PermissionsWrapper>
          <UserPermissionsForm user={user} togglePermission={togglePermission} setEnabledAdmin={setEnabledAdmin} enableAdmin={enableAdmin}/>
        </PermissionsWrapper>
      </Fragment>
    );
  }
  if (!currentUser.admin) {
    return (
      <Fragment>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 15}}>
          <Link href="/api/auth/reset">Reset your password</Link>
        </div>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 15}}>
          <Link href="/api/auth/reset-mfa">Reset your MFA phone number</Link>
        </div>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 15}}>
          <Link href="/api/auth/reset-otp">Reset your One Time Passcode</Link>
        </div>
      </Fragment>
    )
  }
};

const PermissionsWrapper = styled.div`
  margin: 50px auto;
  width: 100%;
`;

const useStyles = makeStyles()((theme: Theme) =>
  ({
    forgotPasswordLink: {
      color: colors.white,
      textDecoration: 'underline',
      textAlign: 'center',
      fontSize: '1.15em',
    },
  })
);
